<div  class="content-container">
    <div class="text">
        <p>Confirma o valor de adesão de saldo ? <br /><br />
            <span class="amount">{{ data.totalAmount | currency }}</span>
        </p>
        <br />
        <div>
            <p>Escolha um método de pagamento:</p>
            <br />
            <mat-radio-group (change)="paymentMethod($event.value)" style="display: flex; min-height: 50px; justify-content: space-around; align-content: center;">
                <mat-radio-button value="PIX" class="payment-method">PIX</mat-radio-button>
                <mat-radio-button value="CREDIT_CARD" class="payment-method">Cartão de Crédito</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="selectPayment">
                Selecione um metodo de pagamento
            </mat-error>
        </div>
        <br />
        <br />
    </div>

    <div class="actions-container">
        <button mat-button (click)="onConfirm()" class="btn-primary">
            Confirmar
        </button>

        <button mat-button (click)="onDeny()">
            Cancelar
        </button>
    </div>
</div>
